// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import { WorkbookVariantFragmentFragmentDoc } from "../../Workbook/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateWorkbookCollectorRunMutationVariables = Types.Exact<{
  variantId: Types.Scalars["ID"]["input"];
}>;

export type CreateWorkbookCollectorRunMutation = {
  __typename?: "Mutation";
  createWorkbookCollectorRun: {
    __typename?: "WorkbookVariant";
    id: string;
    createdAt: number;
    updatedAt: number;
    description?: string | null;
    queryFingerprint: string;
    queryText: string;
    name: string;
    queryTextWithAlias: string;
    paramRefAliasMap: any;
    draft: boolean;
    plannerSettings: any;
    appliedInsights?: any | null;
    workbookResults: Array<{
      __typename?: "WorkbookResult";
      id: string;
      format: string;
      resultSource: string;
      createdAt: number;
      updatedAt: number;
      status?: string | null;
      errorMessage?: string | null;
      totalCost?: number | null;
      totalSharedBlksHit?: number | null;
      totalSharedBlksRead?: number | null;
      totalSharedBlksWritten?: number | null;
      totalSharedBlksDirtied?: number | null;
      totalBlkReadTime?: number | null;
      totalBlkWriteTime?: number | null;
      planNodeTypes?: Array<string | null> | null;
      runtimeMs?: number | null;
      planFingerprint?: string | null;
      parameterSetId?: string | null;
      nodeInsights?: any | null;
      user?: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
      } | null;
    }>;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    queryTextWithParameters: Array<{
      __typename?: "QueryTextWithParameters";
      id: string;
      parameterSetId: string;
      queryWithParameters: string;
    }>;
  };
};

export const CreateWorkbookCollectorRunDocument = gql`
  mutation CreateWorkbookCollectorRun($variantId: ID!) {
    createWorkbookCollectorRun(variantId: $variantId) {
      ...WorkbookVariantFragment
    }
  }
  ${WorkbookVariantFragmentFragmentDoc}
`;
export type CreateWorkbookCollectorRunMutationFn = Apollo.MutationFunction<
  CreateWorkbookCollectorRunMutation,
  CreateWorkbookCollectorRunMutationVariables
>;

/**
 * __useCreateWorkbookCollectorRunMutation__
 *
 * To run a mutation, you first call `useCreateWorkbookCollectorRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkbookCollectorRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkbookCollectorRunMutation, { data, loading, error }] = useCreateWorkbookCollectorRunMutation({
 *   variables: {
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useCreateWorkbookCollectorRunMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkbookCollectorRunMutation,
    CreateWorkbookCollectorRunMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkbookCollectorRunMutation,
    CreateWorkbookCollectorRunMutationVariables
  >(CreateWorkbookCollectorRunDocument, options);
}
export type CreateWorkbookCollectorRunMutationHookResult = ReturnType<
  typeof useCreateWorkbookCollectorRunMutation
>;
export type CreateWorkbookCollectorRunMutationResult =
  Apollo.MutationResult<CreateWorkbookCollectorRunMutation>;
export type CreateWorkbookCollectorRunMutationOptions =
  Apollo.BaseMutationOptions<
    CreateWorkbookCollectorRunMutation,
    CreateWorkbookCollectorRunMutationVariables
  >;
